import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function WithGA({ children }) {
  const location = useLocation();
  useEffect(() => ReactGA.send('pageview'), [location]);

  return children;
}

export default WithGA;
